import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
function ProtectedRoute() { const { user, loading } = useAuth(); const location = useLocation(); if (loading) return <div className="auth-loading"><div className="auth-spinner"/><p>Checking your session...</p></div>; return user ? <Outlet /> : <Navigate to="/login" replace state={{ from: location }} />; }
export default ProtectedRoute;
